function customAddToCartJS(e, t = 1) {
    return new Promise((a, n) => {
        setTimeout(() => {
            fetch("/cart.js")
                .then((e) => e.json())
                .then((d) => {
                    let r = d.items.find((t) => t.variant_id === e);
                    if (r && r.quantity >= 1)
                        console.log("Product already in cart with quantity 1 or more. No further increase allowed."),
                            a();
                    else {
                        var o = new XMLHttpRequest();
                        o.open("POST", "/cart/add.js", !0),
                            o.setRequestHeader("Content-Type", "application/json"),
                            (o.onreadystatechange = function () {
                                4 === o.readyState &&
                                    (200 === o.status
                                        ? (JSON.parse(o.responseText),
                                          document.documentElement.dispatchEvent(
                                              new CustomEvent("cart:refresh", { bubbles: !0 })
                                          ),
                                          console.log("Cart Refreshed from add to cart functoin"),
                                          a())
                                        : n(o.statusText));
                            });
                        var i = JSON.stringify({ quantity: t, id: e });
                        o.send(i);
                    }
                })
                .catch((e) => n(e));
        }, 1e3);
    });
}
function removeFromCartJS(e) {
    return new Promise((t, a) => {
        var n = new XMLHttpRequest();
        n.open("POST", "/cart/change.js", !0),
            n.setRequestHeader("Content-Type", "application/json"),
            (n.onreadystatechange = function () {
                4 === n.readyState &&
                    (200 === n.status
                        ? (JSON.parse(n.responseText),
                          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: !0 })),
                          console.log("Cart Refreshed from remove functoin"),
                          t())
                        : a(n.statusText));
            });
        var d = JSON.stringify({ quantity: 0, id: e });
        n.send(d);
    });
}
const addOnData = {
        "loss-protection": {
            title: "Loss Protection",
            price: "$30.00",
            image: "https://cdn.shopify.com/s/files/1/0828/3255/6268/files/Loss_Protection_3.svg?v=1787293074",
            description: "Safeguard your order from loss during shipping.",
            pid: "48207803449580",
        },
        "damage-protection": {
            title: "Damage Protection",
            price: "$100.00",
            image: "https://cdn.shopify.com/s/files/1/0828/3255/6268/files/Damage_Protection_3.svg?v=1787293073",
            description: "Protect your order from shipping damage.",
            pid: "48207796469996",
        },
        "theft-protection": {
            title: "Theft Protection",
            price: "$20.00",
            image: "https://cdn.shopify.com/s/files/1/0828/3255/6268/files/Theft_Protection_3.svg?v=1787293074",
            description: "Protect your purchase from theft during shipping.",
            pid: "48207805939948",
        },
    },
    bindCartRefreshEvent = (e) => {
        e.addEventListener("click", () => {
            console.log("update clicked"),
                setTimeout(() => {
                    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: !0 }));
                }, 500);
        });
    },
    addEventToEachIcon = () => {
        document.removeEventListener("click", addonIconClickHandler),
            document.addEventListener("click", addonIconClickHandler);
    },
    addonIconClickHandler = async (e) => {
        let t = e.target.closest(".addon-icon");
        if (!t) return;
        e.preventDefault();
        let a = t.getAttribute("data-addontype"),
            n = addOnData[a];
        if (!n) return;
        (document.querySelector(".addon-title").textContent = n.title),
            (document.querySelector(".addon-price").textContent = n.price),
            (document.querySelector(".addon-description").textContent = n.description),
            (document.querySelector(".addon-image").src = n.image);
        let d = await fetch("/cart.js").then((e) => e.json()),
            r = d.items.find((e) => e.variant_id == n.pid),
            o = document.querySelector(".addon-add-to-cart"),
            i = document.querySelector(".addon-remove-from-cart");
        o.setAttribute("data-pid", n.pid),
            i.setAttribute("data-pid", n.pid),
            r
                ? (o.classList.add("hidden"), i.classList.remove("hidden"))
                : (o.classList.remove("hidden"), i.classList.add("hidden")),
            document.getElementById("addon-info-panel").classList.add("active");
    },
    popUpHandler = () => {
        let e = document.querySelectorAll(".mini-cart__quantity-remove"),
            t = document.querySelectorAll(".quantity-selector__button");
        e.forEach(bindCartRefreshEvent),
            t.forEach(bindCartRefreshEvent),
            addEventToEachIcon(),
            document.addEventListener("click", (e) => {
                let t = document.getElementById("addon-info-panel"),
                    a = t.contains(e.target),
                    n = e.target.classList.contains("addon-icon");
                a || n || t.classList.remove("active");
            });
    },
    addButtonFunctionality = () => {
        let e = document.querySelector(".addon-add-to-cart");
        if (!e) return;
        let t = e.cloneNode(!0);
        e.parentNode.replaceChild(t, e),
            t.addEventListener(
                "click",
                async (e) => {
                    e.preventDefault();
                    let a = t.dataset.pid;
                    if (!a) return;
                    console.log("Adding product..."), await customAddToCartJS(a), console.log("Product added.");
                    let n = document.querySelector(`.addon-icon[data-productid="${a}"]`);
                    n && n.classList.add("added"),
                        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: !0 }));
                },
                { once: !0 }
            );
    },
    handleCartUIUpdate = () => {
        setTimeout(() => {
            popUpHandler(), addButtonFunctionality();
        }, 1e3);
    };
document.addEventListener("cart:refresh", handleCartUIUpdate),
    document.addEventListener("product:added", handleCartUIUpdate),
    document.addEventListener("DOMContentLoaded", () => {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: !0 }));
    });
const addClassToElements = () => {
        fetch("/cart.js")
            .then((e) => e.json())
            .then((e) => {
                e.items.forEach((e) => {
                    document.querySelector(`.addon-icon[data-productid="${e.variant_id}"]`)?.classList?.add("added");
                });
            });
    },
    cartManager = () => {
        setTimeout(() => {
            let e = document.querySelector(".damage-protection"),
                t = document.querySelector(".theft-protection"),
                a = document.querySelector(".loss-protection"),
                n = document.querySelectorAll(".addon-icon"),
                d = document.querySelectorAll(".mini-cart__line-item"),
                r = Object.values(d).filter(
                    (n) =>
                        n.id.includes(e.dataset.productid) ||
                        n.id.includes(t.dataset.productid) ||
                        n.id.includes(a.dataset.productid)
                );
            async function o() {
                for (let [e, t] of n.entries())
                    await customAddToCartJS(+t.dataset.productid, 1), console.log("added " + e);
            }
            async function i() {
                for (let e of r) await removeFromCartJS(e.dataset.itemkey), console.log(e.dataset.itemkey);
            }
            r.length === d.length
                ? i()
                : 0 == r.length && d.length <= 1 && (console.log("All products Added to cart"), o());
        }, 1e3),
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: !0 }));
    },
    cartRefreshManager = () => {
        setTimeout(() => {
            let e = document.querySelector(".damage-protection"),
                t = document.querySelector(".theft-protection"),
                a = document.querySelector(".loss-protection"),
                n = document.querySelectorAll(".mini-cart__line-item"),
                d = Object.values(n).filter(
                    (n) =>
                        n.id.includes(e.dataset.productid) ||
                        n.id.includes(t.dataset.productid) ||
                        n.id.includes(a.dataset.productid)
                );
            async function r() {
                for (let e of d)
                    await removeFromCartJS(e?.dataset?.itemkey),
                        console.log("Removed item productid: " + e?.dataset?.itemkey);
            }
            console.log("Removal Condition "),
                console.log(d.length === n.length),
                d.length === n.length && (console.log("Removal Condition Matched"), r());
        }, 1e3);
    };
document.addEventListener("product:added", cartManager),
    document.addEventListener("cart:refresh", cartRefreshManager),
    document.addEventListener("cart:refresh", () => {
        setTimeout(() => {
            popUpHandler(),
                addClassToElements(),
                document.querySelectorAll(".mini-cart__line-item").length > 0 &&
                    (addRemoveFunctionality(), addButtonFunctionality());
        }, 1e3);
    }),
    document.addEventListener("product:added", () => {
        setTimeout(() => {
            popUpHandler(),
                document.querySelectorAll(".mini-cart__line-item").length > 0 &&
                    (addRemoveFunctionality(), addClassToElements()),
                addButtonFunctionality();
        }, 1e3);
    }),
    document.addEventListener("DOMContentLoaded", () => {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: !0 }));
    }),
    document.addEventListener("click", async (e) => {
        let t = e.target.closest(".addon-remove-from-cart");
        if (!t) return;
        e.preventDefault();
        let a = t.dataset.pid;
        if (!a) {
            console.error("No product ID found.");
            return;
        }
        try {
            let n = await fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: a, quantity: 0 }),
            });
            if (!n.ok) throw Error("Failed to remove item");
            await n.json(), document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: !0 }));
        } catch (d) {
            console.error("Error removing item from cart:", d);
        }
    });
